module.exports = __webpack_public_path__ + "img/printer.30802e5e.png";